import { Box, Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { TextDisplayCell } from "../../../common/components/DataGrid";
import { generateParentTagCell } from "../../helpers/CellGenerators";

const unresolvedTooltipText =
  "Showing the Tag Identifier — no tag with this identifier was found in the current grid on the same Asset, so its Tag Name can't be resolved.";

export const ParentTagCell = ({ row, allTags }) => {
  const parentTag = generateParentTagCell(row, allTags);

  if (!parentTag) {
    return null;
  }

  if (parentTag.resolved) {
    return <TextDisplayCell value={parentTag.tagName} />;
  }

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        minWidth: 0,
      }}>
      <TextDisplayCell value={parentTag.tagIdentifier} />
      <Tooltip title={unresolvedTooltipText}>
        <Box
          component='span'
          aria-label='Parent tag identifier info'
          sx={{ display: "inline-flex", alignItems: "center" }}>
          <InfoOutlined color='action' sx={{ fontSize: 16 }} />
        </Box>
      </Tooltip>
    </Box>
  );
};
